import React, { Component } from "react";
import { RTRegistrationProps, TrackIndex } from "./RTRegistration";
import Strings from "@my-dld/assets/strings";
import { I8N, StringUtil } from "@eres/core";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { openDocument } from "@my-dld/utils/Utils";
import { showErrorMessage } from "@my-dld/utils/UIUtils";
import AddPartyPopup from "@my-dld/components/RTRegistration/AddPartyPopup";
import AddPartyOnlyNamePopup from "@my-dld/components/RTRegistration/AddPartyOnlyNamePopup";
import { Party, ProcedureDoc, Role } from "@eres/rtregistrationapi/entities";

interface State {
	roles: Role[];
	showPopup?: boolean;
	showNameOnlyPopup?: boolean;
	selRole?: Role;
	editIndex?: number;
}

class RoleWithParties extends Component<RTRegistrationProps, State> {
	constructor( props: RTRegistrationProps ) {
		super( props );
		this.state = {
			roles: props.procedure.Roles,
		};
	}

	render() {
		const { roles, showPopup, showNameOnlyPopup, selRole, editIndex } = this.state;
		return <React.Fragment>
			<div className="card party-info-card" id="party_information">
				{ roles && roles.map( ( role: Role ) => {
					return <RenderRole key={ "role_" + role.RoleOrder } role={ role } onAddParty={ this.onAddParty }/>;
				} ) }
				<div className="form-group btn-party-action">
					<button className="btn btn_style1 btn-grey" onClick={ this.onBack }>{ Strings.back }</button>
					<button className="btn btn_1 btn_style1" onClick={ this.onProceed }>{ Strings.proceed }</button>
				</div>
			</div>
			{ showPopup && selRole && <AddPartyPopup
				role={ selRole } editIndex={ editIndex }
				onDismiss={ this.onModelDismiss }/> }
			{ showNameOnlyPopup && selRole && <AddPartyOnlyNamePopup
				role={ selRole } editIndex={ editIndex }
				onDismiss={ this.onModelDismiss }/> }
		</React.Fragment>;
	}

	private onAddParty = ( role: Role, editIndex?: number ) => {
		this.setState( {
			showPopup: !role.OnlyNameAdd,
			showNameOnlyPopup: role.OnlyNameAdd,
			selRole: role,
			editIndex: editIndex,
		}, () => {
			if ( role.OnlyNameAdd ) {
				JQModal( "AddPartyOnlyNamePopup" ).show();
			} else {
				JQModal( "AddPartyPopup" ).show();
			}
		} );
	};

	private onModelDismiss = ( role?: Role ) => {
		const { roles } = this.state;
		this.setState( {
			selRole: undefined,
			showPopup: false,
			showNameOnlyPopup: false,
			roles: role ? roles.map( ( roleItem: Role ) => roleItem.RoleOrder === role.RoleOrder ? role : roleItem ) : roles,
		} );
	};

	private onBack = () => {
		const procedure = this.props.holder.state.procedure;
		procedure.Roles = this.state.roles;
		this.props.onPrevious( TrackIndex.PARTY_INFO );
	};

	private onProceed = () => {
		if ( this.isValid() ) {
			const procedure = this.props.holder.state.procedure;
			procedure.Roles = this.state.roles;
			this.props.onNext( TrackIndex.PARTY_INFO );
		} else {
			const error = Strings.rt_role_parties_validation + "\n" + Strings.rt_party_share_validation +
				"\n" + Strings.rt_party_doc_validation;
			showErrorMessage( error );
		}
	};

	private isValid() {
		const { roles } = this.state;
		for ( let role of roles ) {
			if ( getPartiesShare( role ) < 100 ) {
				return false;
			} else if ( !role.OnlyNameAdd ) {
				for ( let party of role.Parties ) {
					if ( party.Documents == undefined ) {
						return false;
					}
				}
			}
		}
		return true;
	}
}

function RenderRole( props: { role: Role, onAddParty: ( role: Role, editIndex?: number ) => void } ) {
	const { role, onAddParty } = props;
	const roleName = I8N.isRTL() ? role.RoleNameAr : role.RoleName;
	const addName = Strings.add + " " + roleName;
	const canAdd = ( role.CanAdd && getPartiesShare( role ) < 100 );
	return <div className="party-wrap">
		<div className="card-header party-info-section-title">
			<div>{ Strings.party_information + " - " + roleName }</div>
			{ canAdd && <button
				type="button" className="btn btn_1 btn-sm"
				onClick={ () => onAddParty( role ) }><i className="fas fa-plus"/>{ addName }</button> }
		</div>
		{ role.Parties && role.Parties.map( ( party: Party, index: number ) => {
			return role.OnlyNameAdd ? <RenderRolePartyOnlyName
					key={ "role_party_only_name_" + index }
					roleName={ roleName }
					party={ party }
					onEdit={ () => onAddParty( role, index ) }/> :
				<RenderRoleParty
					key={ "role_party_" + index }
					roleName={ roleName }
					party={ party }
					onEdit={ () => onAddParty( role, index ) }/>;
		} ) }
	</div>;
}

function RenderRoleParty( props: { roleName: string, party: Party, onEdit: () => void } ) {
	const { roleName, party, onEdit } = props;
	const docs: ProcedureDoc[] = [];
	if ( party.Documents && party.Documents.length > 0 ) {
		party.Documents.forEach( ( partyDoc: ProcedureDoc ) => {
			if ( partyDoc.Path && !StringUtil.isEmptyStringOrNull( partyDoc.Path ) ) {
				docs.push( partyDoc );
			}
		} );
	}
	return <div className="party-info">
		<div className="card-header">
			<div className="label-value-wrap">
				<span>{ I8N.isRTL() ? party.ArabicName : party.EnglishName }</span>
			</div>
			<button type="button" className="btn btn-sm btn-edit" onClick={ onEdit }>
				<i className="fas fa-pencil-alt"/>{ Strings.edit }
			</button>
		</div>
		<ul className="party-info-card-inner">
			<li>
				<span>{ roleName + " " + Strings.share_percentage }</span>
				<span>{ party.SharePerc ? ( party.SharePerc + "%" ) : ( party.SharePerc === 0 ) ? "0%" : "-" }</span>
			</li>
			<li>
				<span>{ Strings.mobile_number }</span>
				<span>{ ( party.Mobile && !StringUtil.isEmptyStringOrNull( party.Mobile ) ) ? party.Mobile : "-" }</span>
			</li>
			<li>
				<span>{ Strings.email }</span>
				<span>{ ( party.Email && !StringUtil.isEmptyStringOrNull( party.Email ) ) ? party.Email : "-" }</span>
			</li>
			<li>
				<span>{ Strings.emirates_id }</span>
				<span>{ ( party.EID && !StringUtil.isEmptyStringOrNull( party.EID ) ) ? party.EID : "-" }</span>
			</li>
			<li>
				<span>{ Strings.nationality }</span>
				<span>{ party.country ? ( I8N.isRTL() ? party.country!.CountryNameAr : party.country!.CountryNameEn ) : "-" }</span>
			</li>
			<li>
				<span>{ Strings.passport_label }</span>
				<span>{ ( party.Passport && !StringUtil.isEmptyStringOrNull( party.Passport ) ) ? party.Passport : "-" }</span>
			</li>
			{ docs.length > 0 && <li>
				<span>{ Strings.documents }</span>
				<span>
                    { docs.map( ( doc: ProcedureDoc, index: number ) => {
	                    return <React.Fragment key={ "party_doc_" + index }>
		                    <a
			                    className="underline" onClick={ () => {
			                    openDocument( doc.Path!, "Party Document" );
		                    } }>{ doc.doc!.fileName }</a>
		                    <br/>
	                    </React.Fragment>;
                    } ) }
                </span>
			</li>
			}
		</ul>
	</div>;
}

function RenderRolePartyOnlyName( props: { roleName: string, party: Party, onEdit: () => void } ) {
	const { roleName, party, onEdit } = props;
	return <div className="party-info">
		<div className="card-header">
			<div className="label-value-wrap">
				<span>{ I8N.isRTL() ? party.ArabicName : party.EnglishName }</span>
			</div>
			<button type="button" className="btn btn-sm btn-edit" onClick={ onEdit }>
				<i className="fas fa-pencil-alt"/>{ Strings.edit }
			</button>
		</div>
		<ul className="party-info-card-inner">
			<li>
				<span>{ roleName + " " + Strings.share_percentage }</span>
				<span>{ party.SharePerc ? ( party.SharePerc + "%" ) : ( party.SharePerc === 0 ) ? "0%" : "-" }</span>
			</li>
		</ul>
	</div>;
}

function getPartiesShare( role: Role ) {
	let total = 0;
	if ( role && role.Parties ) {
		role.Parties.forEach( ( party: Party ) => {
			total += party.SharePerc ? party.SharePerc : 0;
		} );
	}
	return total;
}

export default RoleWithParties;
